import aos from 'aos'
import 'bootstrap'
import fontawesome from '@fortawesome/fontawesome'
import faFacebook from '@fortawesome/fontawesome-free-brands/faFacebook'
import faInstagram from '@fortawesome/fontawesome-free-brands/faInstagram'
import leaflet from 'leaflet'
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png'
import iconUrl from 'leaflet/dist/images/marker-icon.png'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'

import './index.scss'

function initLeaflet () {
  leaflet.Marker.prototype.options.icon = leaflet.icon({
    iconRetinaUrl,
    iconUrl,
    shadowUrl,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41]
  })

  const mymap = leaflet.map('map', {
    scrollWheelZoom: false
  }).setView([34.764542, -83.063234], 15)

  leaflet.tileLayer('https://a.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>',
      maxZoom: 18
  }).addTo(mymap)

  const marker = leaflet.marker([34.764542, -83.063234]).addTo(mymap)
  marker.bindPopup("224 East Main St<br>Walhalla, South Carolina").openPopup()
}

function init () {
  aos.init()
  initLeaflet()
  fontawesome.library.add(faFacebook, faInstagram)
}

init()
